import React from "react";
import { Quote, Star } from "lucide-react";

const TestimonialCard = ({ testimonial, variant = "default" }) => {
  return (
    <div
      data-testid={`testimonial-card-${testimonial.id}`}
      className="relative bg-white rounded-3xl p-8 lg:p-10 border border-stone-200/70 hover:shadow-lg transition-shadow duration-500 h-full flex flex-col"
    >
      <Quote className="w-10 h-10 text-amber-700/20 mb-4" strokeWidth={1.5} />

      <div className="flex gap-1 mb-5">
        {Array.from({ length: testimonial.rating }).map((_, i) => (
          <Star key={i} className="w-4 h-4 text-amber-600 fill-amber-600" />
        ))}
      </div>

      <p className="text-slate-700 text-base lg:text-lg leading-relaxed mb-8 font-normal flex-1">
        "{testimonial.quote}"
      </p>

      <div className="border-t border-stone-200 pt-5 mt-auto">
        <p className="font-serif text-lg text-slate-900">{testimonial.name}</p>
        <p className="text-sm text-slate-500 mt-1">
          {testimonial.relationship} &middot; {testimonial.location}
        </p>
      </div>
    </div>
  );
};

export default TestimonialCard;
